import axios from "axios";
import {
  API_BASE_URL,
  HEADER_TOKEN,
  SERVER_BASE_URL,
} from "../../configs/AppConfig";
import { AUTH_TOKEN } from "../../redux/constants/Auth";
import { notification } from "antd";

export const ApiService = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? SERVER_BASE_URL
      : API_BASE_URL,
  timeout: 60000,
});

ApiService.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN);
    if (jwtToken) {
      config.headers[HEADER_TOKEN] = `Bearer ${jwtToken}`;
    }
    return config;
  },
  (error) => {
    // Do something with request error here
    notification.error({ message: "Error" });
    Promise.reject(error);
  }
);

export const handlerError = (error) => {
  let notificationParam = { message: "" };

  // Remove token and redirect
  if (error.response?.status === 401) {
   /*  console.log("signOut");
    notificationParam.message = "Error de Autenticación";
    notificationParam.description = "Redirigiendo a la página de acceso";
     */
    localStorage.removeItem(AUTH_TOKEN);
    window.location.reload();

    //Retraso la carga para que aparezca el mensaje de fallo
    //setTimeout(() => window.location.reload(), 1000);
  }

  if (error.response?.status === 404) {
    notificationParam.message = "Not Found";
  }

  if (error.response?.status === 500) {
    notificationParam.message = "Internal Server Error";
  }

  if (error.response?.status === 508) {
    notificationParam.message = "Time Out";
  }

  notification.error(notificationParam);

  return Promise.reject(error);
};
